<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item label="标题/ID">
              <a-input v-model="filterForm.title" placeholder="需求标题/ID" class="form-model-item" allow-clear @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="需求类型">
              <a-select v-model="filterForm.requirement_type" allow-clear @change="handleChange">
                <a-select-option v-for="(item, key) in storyTypes" :key="key" :value="item.value">
                  <a-badge :color="item.color" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" mode="multiple" placeholder="需求状态" allow-clear @change="handleChange">
                <a-select-option v-for="(item, index) in storyStatus" :key="index" :value="item.value">
                  <a-badge :status="item.status" :text="item.label" />
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="所属项目">
              <a-select v-model="filterForm.projectList" mode="multiple" show-search placeholder="需求所属项目" allow-clear @focus="getVersionData" @change="handleChange">
                <a-select-option v-for="version in versionData" :key="version.project_id" :value="version.project_id"> {{ version.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="负责人">
              <a-select v-model="filterForm.handlers" mode="multiple" show-search placeholder="需求负责人" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="优先级">
              <a-select v-model="filterForm.priority" placeholder="优先级" mode="tags" style="width: 100%" allow-clear @change="handleChange">
                <a-select-option v-for="item in ['P0', 'P1', 'P2', 'P3']" :key="item" :value="item"> {{ item }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="创建人">
              <a-select v-model="filterForm.creator" show-search placeholder="需求创建人" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="标签">
              <a-select v-model="filterForm.tagData" mode="multiple" show-search placeholder="标签" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(tag, index) in tagData" :key="index" :value="tag.id">{{ tag.name }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="产品">
              <a-select v-model="filterForm.pm" mode="multiple" show-search placeholder="产品经理" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="运营">
              <a-select v-model="filterForm.operators" mode="multiple" show-search placeholder="运营负责人" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="质量">
              <a-select v-model="filterForm.qa" mode="multiple" show-search placeholder="质量负责人" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="处理人">
              <a-select v-model="filterForm.task_handlers" mode="multiple" show-search placeholder="任务处理人" :filter-option="utils.filterOption" allow-clear @change="handleChange">
                <a-select-option v-for="(user, index) in userData" :key="index" :value="user.id">{{ user.nickname }} </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="临时需求">
              <a-select v-model="filterForm.is_temporary" placeholder="临时需求" allow-clear @change="handleChange">
                <a-select-option :value="1"> 是 </a-select-option>
                <a-select-option :value="0"> 否 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item v-show="expand" label="时间筛选" :label-col="{ span: 3 }">
              <a-input-group compact>
                <a-select v-model="filterForm.time_filter_key" style="width: 30%" @change="handleChange">
                  <a-select-option value="start_time"> 开始时间 </a-select-option>
                  <a-select-option value="end_time"> 结束时间 </a-select-option>
                  <a-select-option value="created_time"> 创建时间 </a-select-option>
                  <a-select-option value="updated_time"> 更新时间 </a-select-option>
                </a-select>
                <a-date-picker v-model="filterForm.start_time" style="width: 35%" placeholder="开始时间" value-format="YYYY-MM-DD" @change="handleChange" />
                <a-date-picker v-model="filterForm.end_time" style="width: 35%" placeholder="结束时间" value-format="YYYY-MM-DD" @change="handleChange" />
              </a-input-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="拆分完成">
              <a-select v-model="filterForm.split_done" placeholder="是否拆分完成" allow-clear @change="handleChange">
                <a-select-option :value="1"> 是 </a-select-option>
                <a-select-option :value="0"> 否 </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item v-show="expand" label="业务需求">
              <business-requirement-select v-model="filterForm.business_requirement" @change="handleChange" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="getStoryList">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
            <a class="ant-dropdown-link" @click="expand = !expand">{{ expand ? '收起' : '展开' }} <a-icon :type="expand ? 'up' : 'down'" /> </a>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="需求列表" size="small" class="filter-data">
      <span slot="extra">
        <story-view ref="view" @setFilter="setFilter" />
        <span v-if="false" class="add">
          <a-dropdown size="small">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <span style="color: #1890ff"><a-icon type="plus" /> 添加 </span><a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item key="1">
                <a @click="onAdd(false)">需求</a>
              </a-menu-item>
              <a-menu-item key="2">
                <a @click="onAdd(true)">故事</a>
              </a-menu-item>
              <a-menu-item key="3">
                <a @click="onAddContract(true)">合同</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </span>
      <a-table :expand-icon-column-index="2" :scroll="{ x: 1200 }" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="key" :loading="loading" :expanded-row-keys.sync="expandedRowKeys" @change="handleTableChange">
        <span slot="customerTitle" slot-scope="text, record">
          <story-title-edit v-if="record.item_type === 'requirement'" :title="record.title" :story-id="record.id" :parent_id="record.parent_id" :is-story="record.requirement_type == 4" :project_id="record.project.id" @change="getStoryList" />
          <task-name-edit v-else-if="record.item_type === 'task'" :name="record.name" :task-id="record.id" :project_id="record.project.id" @change="getStoryList" />
        </span>
        <span slot="customTitleHeader">
          <div :class="`ant-table-row-expand-icon ant-table-row-${expanded === true ? 'expanded' : 'collapsed'}`" style="font-weight: normal" @click="expanded = !expanded" />
          标题
        </span>
        <span slot="customKey" slot-scope="text, record">
          <div v-if="record.is_temporary" class="corner" />
          {{ record.key }}
        </span>
        <template slot="split_done" slot-scope="text, record">
          <span v-if="record.split_done == 0">否</span>
          <span v-if="record.split_done == 1">是</span>
        </template>
        <span slot="status" slot-scope="text, record">
          <story-status-edit v-if="record.item_type === 'requirement'" :story-id="record.id" :status="record.status" @change="getStoryList" />
          <task-status-edit v-else :task-id="record.id" :next-status="record.next_status" :status="record.status" @change="getStoryList" />
        </span>
        <span slot="priority" slot-scope="text, record">
          <story-priority-edit v-if="record.item_type === 'requirement'" :value="record.priority" :story-id="record.id" @change="getStoryList" />
          <task-priority-edit v-else :value="record.priority" :task-id="record.id" @change="getStoryList" />
        </span>
        <span slot="isReview" slot-scope="text, record">
          <review-time-edit v-if="record.item_type === 'requirement'" :value="record.is_review" :data-source="record" item-name="is_review" @change="getStoryList" />
        </span>
        <span slot="technicalReview" slot-scope="text, record">
          <review-time-edit v-if="record.item_type === 'requirement'" :value="record.technical_review" :data-source="record" item-name="technical_review" @change="getStoryList" />
        </span>
        <span slot="type" slot-scope="text, record">
          <story-type-edit v-if="record.item_type === 'requirement'" :value="record.requirement_type" :story-id="record.id" @change="getStoryList" />
        </span>
        <span slot="progress" slot-scope="text, record">
          <a-progress v-if="record.item_type === 'requirement'" :percent="record.progress.progress" size="small" />
        </span>
        <span slot="taskTotal" slot-scope="text, record">
          <span v-if="record.item_type === 'requirement'">
            {{ record.progress.total || 0 }}<span class="task-points">({{ (record.progress.total || 0) * 2 }}人时)</span>
          </span>
          <task-point-edit v-else :value="record.point" :task-id="record.id" @change="getStoryList" />
        </span>
        <span slot="storyPoint" slot-scope="text, record">
          <story-point-edit v-if="record.item_type === 'requirement'" :source-data="record" :source-id="record.id" @change="getStoryList" />
          <span v-else>--</span>
        </span>
        <span slot="startTime" slot-scope="text, record">
          <story-date-edit v-if="record.item_type === 'requirement'" :data-source="record" item-name="start_time" @change="getStoryList" />
          <task-date-edit v-else :data-source="record" item-name="pre_start_time" @change="getStoryList" />
        </span>
        <span slot="objective" slot-scope="text, record">
          <a-tag v-if="record.objective && record.objective.length > 0" :color="record.objective[0].color">{{ record.objective[0].name }}</a-tag>
        </span>
        <span slot="endTime" slot-scope="text, record">
          <story-date-edit v-if="record.item_type === 'requirement'" :data-source="record" item-name="end_time" @change="getStoryList" />
          <task-date-edit v-else :data-source="record" item-name="pre_end_time" @change="getStoryList" />
        </span>
        <span slot="version" slot-scope="text, record"> {{ record.version.name || '--' }} </span>
        <template slot="handlers" slot-scope="text, record">
          <story-user-edit v-if="record.item_type === 'requirement'" item="handlers" :value="record.handlers" title="负责人" :source-id="record.id" />
          <task-user-edit v-else :value="record.handlers" :source-id="record.id" />
        </template>
        <template slot="tech_owner" slot-scope="text, record">
          <story-tech-owner-edit v-if="record.item_type === 'requirement'" item="tech_owner" :value="record.tech_owner" title="技术负责人" :source-id="record.id" />
          <task-user-edit v-else :value="record.handlers" :source-id="record.id" />
        </template>
        <template slot="pm" slot-scope="text, record">
          <story-user-edit item="pm" :value="record.pm" title="产品" :source-id="record.id" />
        </template>
        <template slot="operators" slot-scope="text, record">
          <story-user-edit item="operators" :value="record.operators" title="运营" :source-id="record.id" />
        </template>
        <template slot="qa" slot-scope="text, record">
          <story-user-edit v-if="record.item_type === 'requirement'" item="qa" :value="record.qa" title="质量" :source-id="record.id" />
          <task-user-edit v-else item="qa" :value="record.qa" :source-id="record.id" />
        </template>
        <span slot="creator" slot-scope="text, record"> {{ record.creator.nickname }}</span>
        <span slot="tag" slot-scope="text, record">
          <a-popover placement="topLeft">
            <template slot="content">
              <a-tag v-for="(tag, index) in filteredTags(record.tags)" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
            </template>
            <template slot="title">
              <span>标签</span>
            </template>
            <a-tag v-for="(tag, index) in filteredTags(record.tags)" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
          </a-popover>
        </span>
        <template slot="businessRequirements" slot-scope="text, record">
          <a v-for="(item, index) in record.business_requirements" :key="index" :href="requirementLink(item)" target="_blank">BR-{{ item }} </a>
        </template>
        <!-- 暂不使用 -->
        <span v-if="false" slot="action" slot-scope="text, record">
          <a-dropdown placement="bottomCenter">
            <a-icon type="more" />
            <a-menu v-if="record.item_type === 'requirement'" slot="overlay">
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onEdit(record)"><a-icon type="edit" /> 编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onDelete(record)"><a-icon type="delete" /> 删除</a>
              </a-menu-item>
              <a-menu-item v-has="{ code: 'project:requirement:version:update', project: projectId }">
                <story-version-edit :data-source="record" @reload="getStoryList" />
              </a-menu-item>
              <a-menu-item v-if="record.requirement_type !== 4 && record.status !== 7">
                <a class="ant-dropdown-link" @click="onAddSub(record)"><a-icon type="plus" /> 创建子需求 </a>
              </a-menu-item>
              <a-menu-item v-if="record.create_task === true && record.status !== 7">
                <a class="ant-dropdown-link" @click="onAddTask(record)"><a-icon type="plus-square" /> 创建任务</a>
              </a-menu-item>
              <a-menu-item v-has="{ code: 'project:requirement:temporary:update', project: projectId }">
                <a v-if="record.is_temporary" class="ant-dropdown-link" @click="onSetTemporary(record.id, 0)"><a-icon type="close-circle" /> 取消临时需求</a>
                <a v-else class="ant-dropdown-link" @click="onSetTemporary(record.id, 1)"><a-icon type="check-circle" /> 标为临时需求</a>
              </a-menu-item>
              <a-menu-item v-if="record.requirement_type !== 4">
                <a class="ant-dropdown-link" @click="onAddSub(record, true)"><a-icon type="plus" /> 创建故事 </a>
              </a-menu-item>
            </a-menu>
            <a-menu v-else slot="overlay">
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onEditTask(record)"><a-icon type="edit" /> 编辑</a>
              </a-menu-item>
              <a-menu-item v-if="record.codingTask == 1">
                <a class="ant-dropdown-link" @click="onCreateWorkflow(record)"><a-icon type="bell" /> 提审</a>
              </a-menu-item>
              <a-menu-item>
                <a class="ant-dropdown-link" @click="onDeleteTask(record)"><a-icon type="delete" /> 删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </a-card>
    <story-detail :data-source="storyData" :visible="detailVisible" @close="close" />
    <story-edit :data-source="storyData" :visible="editVisible" :story-id="storyId" :parent="parent" :version-id="versionId" :is-story="isStory" @close="close" />
    <contract-edit :data-source="storyData" :visible="contractEditVisible" :story-id="storyId" :parent="parent" :version-id="versionId" :is-story="isStory" @close="close" />
    <task-edit :task-data="taskData" :is-show="editTaskVisible" :task-id="taskId" :version-id="versionId" :requirement="requirement" @close="close" />
    <task-delete-confirm ref="taskDeleteRef" @ok="getStoryList" />
  </div>
</template>
<script>
import { userList } from '@/api/system/auth';
import { tagList } from '@/api/system/tag';
import { projectList } from '@/api/project/project';
import { workflowFastCreate } from '@/api/project/workflow';
import { storyList, storyDelete, storyUpdateItem } from '@/api/project/story';
import { storyStatus, storyPrioritys, storyTypes, storyFields } from '@/utils/dictionary';

import TaskEdit from '@/pages/project/task/components/TaskEdit';
import StoryEdit from '@/pages/project/story/components/StoryEdit';
import StoryView from '@/pages/project/story/components/StoryView';
import StoryDetail from '@/pages/project/story/components/StoryDetail';
import TaskNameEdit from '@/pages/project/task/components/TaskNameEdit';
import TaskDateEdit from '@/pages/project/task/components/TaskDateEdit';
import TaskUserEdit from '@/pages/project/task/components/TaskUserEdit';
import ContractEdit from '@/pages/project/story/components/ContractEdit';
import TaskPointEdit from '@/pages/project/task/components/TaskPointEdit';
import StoryDateEdit from '@/pages/project/story/components/StoryDateEdit';
import StoryTypeEdit from '@/pages/project/story/components/StoryTypeEdit';
import StoryUserEdit from '@/pages/project/story/components/StoryUserEdit';
import TaskStatusEdit from '@/pages/project/task/components/TaskStatusEdit';
import StoryPointEdit from '@/pages/project/story/components/StoryPointEdit';
import StoryTitleEdit from '@/pages/project/story/components/StoryTitleEdit';
import ReviewTimeEdit from '@/pages/project/story/components/ReviewTimeEdit';
import StoryStatusEdit from '@/pages/project/story/components/StoryStatusEdit';
import TaskPriorityEdit from '@/pages/project/task/components/TaskPriorityEdit';
import TaskDeleteConfirm from '@/pages/project/task/components/TaskDeleteConfirm';
import StoryPriorityEdit from '@/pages/project/story/components/StoryPriorityEdit';
import StoryTechOwnerEdit from '@/pages/project/story/components/StoryTechOwnerEdit';

const columns = [
  {
    key: 'action',
    align: 'center',
    width: 30,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    key: 'key',
    width: 94,
    scopedSlots: { customRender: 'customKey' }
  },
  {
    dataIndex: 'title',
    key: 'title',
    width: 560,
    slots: { title: 'customTitleHeader' },
    scopedSlots: { customRender: 'customerTitle' }
  },
  {
    title: '所属迭代',
    dataIndex: 'project.name',
    key: 'project.name',
    width: 120,
    ellipsis: true
  },
  {
    title: '负责人',
    dataIndex: 'handlers',
    key: 'handlers',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '技术负责人',
    dataIndex: 'tech_owner',
    key: 'tech_owner',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'tech_owner' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 140,
    scopedSlots: { customRender: 'status' }
  },
  {
    width: 200,
    title: '关联业务需求',
    scopedSlots: { customRender: 'businessRequirements' }
  },
  {
    title: '标签',
    dataIndex: 'tag',
    key: 'tag',
    width: 140,
    scopedSlots: { customRender: 'tag' }
  },
  {
    title: '是否拆分完成',
    dataIndex: 'split_done',
    key: 'split_done',
    width: 140,
    scopedSlots: { customRender: 'split_done' }
  },
  {
    title: '任务类型',
    dataIndex: 'objective',
    key: 'objective',
    width: 140,
    scopedSlots: { customRender: 'objective' }
  },
  {
    title: '进度',
    width: 110,
    align: 'center',
    key: 'progress',
    scopedSlots: { customRender: 'progress' }
  },
  {
    title: '任务点',
    width: 108,
    key: 'taskTotal',
    scopedSlots: { customRender: 'taskTotal' }
  },
  {
    title: '故事点',
    width: 80,
    align: 'center',
    key: 'storyPoint',
    scopedSlots: { customRender: 'storyPoint' }
  },
  {
    title: '开始时间',
    dataIndex: 'start_time',
    key: 'start_time',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'startTime' }
  },
  {
    title: '结束时间',
    dataIndex: 'end_time',
    key: 'end_time',
    align: 'center',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'endTime' }
  },
  {
    title: '迭代',
    width: 240,
    key: 'version',
    scopedSlots: { customRender: 'version' }
  },
  {
    title: '产品',
    dataIndex: 'pm',
    key: 'pm',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'pm' }
  },
  {
    title: '运营',
    dataIndex: 'operators',
    key: 'operators',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'operators' }
  },
  {
    title: '质量',
    dataIndex: 'qa',
    key: 'qa',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'qa' }
  },
  {
    title: '需求类型',
    dataIndex: 'requirement_type',
    key: 'requirement_type',
    width: 146,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    align: 'center',
    width: 80,
    sorter: true,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '评审时间',
    width: 200,
    align: 'center',
    key: 'isReview',
    scopedSlots: { customRender: 'isReview' }
  },
  {
    title: '技术评审时间',
    width: 200,
    align: 'center',
    key: 'technicalReview',
    scopedSlots: { customRender: 'technicalReview' }
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    align: 'center',
    width: 170
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    align: 'center',
    width: 170
  }
];
export default {
  components: { StoryPointEdit, ContractEdit, StoryDetail, StoryEdit, StoryStatusEdit, StoryUserEdit, StoryTechOwnerEdit, TaskEdit, StoryView, StoryDateEdit, StoryTitleEdit, StoryPriorityEdit, StoryTypeEdit, TaskNameEdit, TaskUserEdit, TaskStatusEdit, TaskPriorityEdit, TaskPointEdit, TaskDateEdit, ReviewTimeEdit, TaskDeleteConfirm },
  data() {
    return {
      columns,
      columnsCopy: JSON.parse(JSON.stringify(columns)),
      storyStatus,
      storyPrioritys,
      storyTypes,
      expand: true,
      loading: false,
      tableData: [],
      userData: [],
      tagData: [],
      tagCounts: {},
      expanded: true,
      expandedRowKeys: [],
      defaultDataKeys: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        sort_field: null,
        sort: null,
        priority: [],
        start_time: null,
        end_time: null,
        handlers: [],
        pm: [],
        operators: [],
        time_filter_key: 'start_time',
        type: 'all_dev',
        business_requirement: null,
        page_size: 20,
        page_number: 1
      },
      versionData: [],
      pagination: {
        size: 'large',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示20条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      editVisible: false,
      contractEditVisible: false,
      detailVisible: false,
      storyData: {},
      storyId: null,
      requirement: {},
      parent: {},
      versionId: null,
      editTaskVisible: false,
      taskData: {},
      taskId: null,
      storyFields,
      isStory: false
    };
  },
  computed: {
    counts() {
      return (record, status) => {
        const p = record.progress.status;
        return p !== null && p[status] !== undefined ? p[status] : 0;
      };
    },
    requirementLink() {
      return record => {
        return this.$router.resolve({
          name: 'page:business:requirement:detail',
          params: { id: record }
        }).href;
      };
    },
    progress() {
      return p => {
        let num = 0;
        let completed = 0;
        if (p === null) {
          return 0;
        }
        for (const item in p) {
          num += p[item];
          if (item === '3') {
            completed += p[item];
          }
        }
        return completed === 0 ? completed : Math.round((completed / num) * 100);
      };
    },
    total() {
      return p => {
        let count = 0;
        if (p !== null) {
          for (const item in p) {
            count += p[item];
          }
        }
        return count;
      };
    },
    handlers() {
      return record => {
        return record.handlers || null;
      };
    },
    pm() {
      return record => {
        return record.pm || null;
      };
    },
    om() {
      return record => {
        return record.operators || null;
      };
    }
  },

  watch: {
    expanded() {
      this.expandedRowKeys = this.expanded === true ? [...this.defaultDataKeys] : [];
    }
  },
  created() {
    // this.getStoryList();
    this.getUserList();
    this.getTagList();
  },

  methods: {
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users;
      });
    },
    onCreateWorkflow(record) {
      const self = this;
      record.template_id = 13;
      record.type = 'task';
      workflowFastCreate({ record }).then(res => {
        if (res.data.message === 'success') {
          self.$message.success('创建成功,正在跳转流程详情页～');
          this.$router.push({
            name: 'page:project:workflow:detail',
            query: { workflowId: res.data.workflow_id }
          });
        } else {
          if (res.data.message) {
            self.$message.warning(res.data.message);
          }
        }
      });
    },
    filteredTags(tags) {
      const uniqueTags = tags.filter((tag, index) => {
        return tags.findIndex(t => t.id === tag.id) === index;
      });

      const tagCounts = tags.reduce((counts, tag) => {
        counts[tag.id] = (counts[tag.id] || 0) + 1;
        return counts;
      }, {});

      return uniqueTags.map(tag => {
        const count = tagCounts[tag.id];
        const processedTag = { ...tag }; // 创建一个新对象来保存处理后的标签
        if (count > 1) {
          processedTag.name = processedTag.name + count + '次';
        }
        return processedTag;
      });
    },
    getStoryList() {
      this.loading = true;
      storyList({ ...this.filterForm, project_id: this.projectId, type: 'all_dev', show_task: true })
        .then(res => {
          this.tableData = res.data.items;
          this.defaultDataKeys = res.data.default_requirement_ids;
          if (this.expandedRowKeys.length === 0) {
            this.expandedRowKeys = this.expanded === true ? [...this.defaultDataKeys] : [];
          }
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getVersionData() {
      projectList({ page_index: 1, page_size: 100 }).then(res => {
        this.versionData = res.data.projects;
      });
    },
    getTagList() {
      tagList({ group_code: 'task_req_tag' }).then(res => {
        this.tagData = res.data.items;
      });
    },
    onReset() {
      this.setFilter({ start_time: null, end_time: null, handlers: [], priority: [], time_filter_key: 'start_time' });
      this.$refs['view'].resetView();
    },

    setFilter(filter) {
      this.filterForm = {
        ...filter,
        page_size: 20,
        page_number: 1
      };
      if (Array.isArray(this.filterForm.fields) && this.filterForm.fields.length > 0) {
        const fields = this.filterForm.fields
          .map(f => {
            return this.storyFields.find(ff => ff.value === f);
          })
          .map(f => f.value);
        this.columns = [
          {
            key: 'action',
            align: 'center',
            width: 30,
            scopedSlots: { customRender: 'action' }
          },
          {
            title: 'ID',
            dataIndex: 'key',
            key: 'key',
            width: 90
          },
          {
            // title: '标题',
            dataIndex: 'title',
            key: 'title',
            width: 560,
            slots: { title: 'customTitleHeader' },
            scopedSlots: { customRender: 'customerTitle' }
          }
        ];
        fields.forEach(f => {
          for (let i = 0; i < this.columnsCopy.length; i++) {
            if (this.columnsCopy[i].key === f && !['key', 'title'].includes(f)) {
              this.columns.push(this.columnsCopy[i]);
            }
          }
        });
      } else {
        this.columns = this.columnsCopy;
      }

      this.pagination.pageSize = 20;
      this.pagination.current = 1;
      this.getStoryList();
    },

    handleChange() {
      this.filterForm.page_number = 1;
      this.pagination.current = 1;
      this.getStoryList();
    },

    handleTableChange(pagination, _, sorter) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.filterForm.sort_field = sorter.field;
      this.filterForm.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getStoryList();
    },

    onAdd(isStory = false) {
      this.isStory = isStory;
      this.editVisible = true;
    },

    onAddContract(isStory = false) {
      this.contractEditVisible = true;
    },

    // 添加子需求
    onAddSub(record, isStory = false) {
      this.isStory = isStory;
      this.editVisible = true;
      this.parent = { key: record.id, label: record.title };
    },

    onEdit(record) {
      this.isStory = record.requirement_type === 4;
      this.storyId = record.id;
      this.storyData = record;
      this.editVisible = true;
    },
    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除这个需求吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          storyDelete({ requirement_id: record.id, project_id: self.projectId }).then(() => {
            self.$message.success('删除成功');
            self.getStoryList();
          });
        }
      });
    },

    onAddTask(record) {
      this.requirement = { key: record.id, label: record.title };
      this.editTaskVisible = true;
    },

    onExpand(expanded, record) {
      if (expanded === true && this.$refs[record.id]) {
        this.$refs[record.id].getTaskList();
      }
    },

    onEditTask(record) {
      this.taskId = record.id;
      this.taskData = record;
      this.editTaskVisible = true;
    },

    onDeleteTask(record) {
      this.$nextTick(() => {
        this.$refs.taskDeleteRef.onOpen(record.id, this.projectId);
      });
    },

    reload(storyId) {
      if (this.$refs[storyId]) {
        this.$refs[storyId].getTaskList();
      }
    },

    close(type) {
      this.storyId = null;
      this.storyData = {};
      this.editVisible = false;
      this.detailVisible = false;
      this.editTaskVisible = false;
      this.contractEditVisible = false;
      this.parent = {};
      if (type !== 'cancel') {
        this.getStoryList();
      }
    },
    onSetTemporary(storyId, value) {
      const self = this;
      this.$confirm({
        title: '确认操作',
        content: `确认${value === 1 ? '标为临时' : '取消临时'}需求吗`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          storyUpdateItem({
            project_id: self.projectId,
            requirement_id: storyId,
            key: 'is_temporary',
            value: value
          }).then(() => {
            self.$message.success('更新成功');
            self.getStoryList();
          });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;

  .ant-form-item-control-wrapper {
    flex: 1;
  }
}

.filter-data {
  margin-top: 16px;
}

.story-title:hover {
  cursor: pointer;
  color: #3582fb;
}

/deep/.customer-data-picker {
  .ant-input {
    padding: 4px 8px;
  }
}

.task-points {
  font-size: 11px;
  color: #8c95a8;
}

/deep/.ant-badge-status-text {
  margin-left: 4px;
}

.corner {
  position: relative;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}

.corner::before {
  position: absolute;
  top: -12px;
  left: -8px;
  font-size: 12px;
  height: 16px;
  content: '临时';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner::after {
  position: absolute;
  content: '';
  clip-path: polygon(0 0, 4px 0, 4px 4px);
  width: 8px;
  height: 8px;
  left: -8px;
  bottom: -12px;
  /* 颜色变暗：filter滤镜、半透明遮罩 */
  /* 使用filter滤镜 使颜色变暗 */
  /*filter: brightness(.6);*/
  /* 给颜色上添加一个半透明遮罩实现颜色变暗 */
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit;
  /* 继承 */
}

.add {
  line-height: 32px;
  float: left;
  margin-left: 10px;
}
</style>
